<!--
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2024-04-09 15:16:27
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2024-04-24 15:28:35
 * @FilePath: /wemeet-iam/Users/hvv/weMeetSpace/wemeet-poster/src/views/mini-h5/pages/contacts/components/enterPriseItem.vue
 * @Description: 
 * Copyright (c) 2024 by WeMeet, All Rights Reserved. 
-->
<template>
  <div class="userItem" @click="goDetail()">
    <!-- -->
    <div class="imgBox">
      <img :src="userInfo.logo" class="img" alt="">
    </div>
    <div class="infoBox">
      <div class="name">{{userInfo.name}}
        <img class="" v-if="userInfo.enterpriseCode" src="https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/WeMeet-Static/WeMeet-mini/images/authGif/auth.gif" mode="" style="width: 20px; height: 20px;display:inline-block;margin-left:10px;"></img>
      </div>
      <!-- <div v-if="item.member && item.member == 'VIP'" class="d-inline-block border-box wmt_bg_color br-40 fz-22 text-white px-14 fw-7 text-center" style="height: 40rpx;line-height: 40rpx;">
        {{appName}}机构会员
      </div> -->
      <!-- <div class="com_position">{{userInfo.company}} · {{userInfo.position}}</div> -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'Useritem',
  props: {
    userInfo: {
      type: Object,
      default: {},
    },
    showControll: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {}
  },

  mounted() {},

  methods: {
    goDetail() {
      if (this.userInfo.enterpriseCode) {
        this.$router.push(`/mini-h5/index/enterpriseMainPage?enterpriseCode=${this.userInfo.enterpriseCode}`)
      } else {
        this.$router.push(`/mini-h5/index/mainPage?uid=${this.userInfo.targetUid}`)
      }
    },
  },
}
</script>


<style lang="less" scoped>
.userItem {
  width: 100%;
  height: 75px;
  padding: 0 12px;
  display: flex;
  margin-bottom: 10px;
  padding-top: 10px;
  .imgBox {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    margin-right: 10px;
    .img {
      width: 100%;
      border-radius: 50%;
      height: 100%;
    }
  }
  .infoBox {
    width: calc(100% - 94px);
    height: 100%;
    border-bottom: 1px solid #d8d8d8;
    .name {
      font-size: 17px;
      color: #262626;
      font-weight: bold;
      display: flex;
    }
    .com_position {
      font-size: 14px;
      color: #262626;
      margin-top: 3px;
    }
  }
}
</style>